import React from "react";
import { getClassName } from "@sscs/utils";
import { toast } from "react-toastify/unstyled";
import CloseButton from "./CloseButton";
import showToast from "./Toast";
import styles from "./toast.module.scss";
import ToastCard from "./ToastCard";
/**
 * Create a progress toast (info / upload / export). All kinds render the
 * `$interactive` bar and border — the chip glyph is the only difference. The
 * returned handle keeps the current props in a closure so `update()` can
 * re-render the card and re-drive toastify's controlled progress bar.
 */
const progressToast = (opts) => {
    let title = opts.title;
    let percent = opts.percent;
    let cancelDisabled = false;
    const renderCard = () => {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(ToastCard, { title: title, progressKind: (_a = opts.kind) !== null && _a !== void 0 ? _a : "info", percent: percent }),
            percent === undefined && React.createElement("div", { className: styles.indeterminate })));
    };
    const dismiss = () => {
        if (toast.isActive(id))
            toast.dismiss(id);
    };
    const closeButton = opts.onCancel
        ? () => (React.createElement(CloseButton, { label: "Cancel", disabled: cancelDisabled, onClick: () => {
                var _a;
                (_a = opts.onCancel) === null || _a === void 0 ? void 0 : _a.call(opts);
                setTimeout(() => dismiss());
            } }))
        : CloseButton;
    const progressOptions = percent !== undefined
        ? {
            progress: percent / 100,
            progressClassName: styles["progress-interactive"],
        }
        : { hideProgressBar: true };
    const id = toast(renderCard(), {
        icon: false,
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton,
        className: getClassName(styles.toast, styles["toast-progress"]),
        ...progressOptions,
        ...opts.props,
    });
    return {
        id,
        update: (patch) => {
            if (patch.title !== undefined)
                title = patch.title;
            if (patch.percent !== undefined)
                percent = patch.percent;
            if (patch.cancelDisabled !== undefined)
                cancelDisabled = patch.cancelDisabled;
            toast.update(id, {
                render: renderCard(),
                closeButton,
                ...(percent !== undefined
                    ? {
                        progress: percent / 100,
                        progressClassName: styles["progress-interactive"],
                    }
                    : {}),
            });
        },
        done: () => toast.done(id),
        error: (data) => {
            dismiss();
            showToast({ ...data, type: "error" });
        },
        dismiss,
        isActive: () => toast.isActive(id),
    };
};
export default progressToast;
//# sourceMappingURL=progressToast.js.map